import * as React from 'react';
import * as SerialPortJs from './serialportjs';

interface Props {
  open?: boolean;
  write?: string;
  onLoad?: (data: any) => void;
  onStatus?: (data: any) => void;
}

export const SerialPort: React.FunctionComponent<Props> = (props) => {

  const onStatus = () => {
    const status = ['Serial reader is not support', 'No device detected', 'Device disconected', 'Device connected']
    return SerialPortJs.currentPortStatus === 4? SerialPortJs.currentPortDevInfo : status[SerialPortJs.currentPortStatus];
  }

  const portOpen = async() => {
    await SerialPortJs.connect();
    props.onStatus?.(onStatus());
    await SerialPortJs.read((value: string) => {if (value.trim() !=='') props.onLoad?.(value)});
  }
  
  const portListen = async() => {
    await SerialPortJs.listen(() => props.onStatus?.(onStatus()) );
  }

  const portWrite = async(data: string) => {
    await SerialPortJs.write(data);
  }

  React.useEffect(() => {

    if ([0,1].includes(SerialPortJs.currentPortStatus)) props.onLoad?.('');
    if (props.open && [1,2,3].includes(SerialPortJs.currentPortStatus)) portOpen();
    if (props.write && [4].includes(SerialPortJs.currentPortStatus)) portWrite(props.write);
    portListen();
    props.onStatus?.(onStatus());
    
    
    
  }, [props.open, props.write, props.onStatus, SerialPortJs.currentPortStatus])
 
  return (
    <></>
  )
  
}